// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

:root {
  --red: #c0392b;
  --red-dark: #96281b;
  --red-light: #f5e6e4;
  --green: #1a5c38;
  --green-mid: #27ae60;
  --green-light: #e8f5ee;
  --blue: #2563eb;
  --blue-dark: #1d4ed8;
  --black: #0d0d0d;
  --gray-900: #1a1a1a;
  --gray-700: #3d3d3d;
  --gray-500: #6b6b6b;
  --gray-300: #b0b0b0;
  --gray-100: #f0f0f0;
  --gray-50: #f8f8f8;
  --white: #ffffff;
  --border: #e2e2e2;
  --shadow-sm: 0 1px 3px rgba(0,0,0,0.08);
  --shadow: 0 2px 8px rgba(0,0,0,0.10);
  --shadow-lg: 0 4px 20px rgba(0,0,0,0.12);
  --radius: 6px;
  --radius-lg: 10px;
}

html { font-size: 14px; }

body {
  font-family: 'DM Sans', -apple-system, sans-serif;
  background: var(--gray-50);
  color: var(--gray-900);
  -webkit-font-smoothing: antialiased;
  line-height: 1.5;
}

h1, h2, h3, h4 {
  font-family: 'DM Serif Display', Georgia, serif;
  font-weight: 400;
  line-height: 1.2;
}

a { color: inherit; text-decoration: none; }

input, textarea, select {
  font-family: inherit;
  font-size: 0.875rem;
}

button { cursor: pointer; font-family: inherit; }

::-webkit-scrollbar { width: 4px; height: 4px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: var(--gray-300); border-radius: 2px; }

/* Utilities */
.text-red { color: var(--red); }
.text-green { color: var(--green); }
.text-muted { color: var(--gray-500); }

/* Animations */
@keyframes fadeIn { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }
@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }

.fade-in { animation: fadeIn 0.3s ease; }

/* Responsive */
@media (max-width: 768px) {
  html { font-size: 13px; }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,yBAAyB,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAExE;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;EACvC,oCAAoC;EACpC,wCAAwC;EACxC,aAAa;EACb,iBAAiB;AACnB;;AAEA,OAAO,eAAe,EAAE;;AAExB;EACE,iDAAiD;EACjD,0BAA0B;EAC1B,sBAAsB;EACtB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,IAAI,cAAc,EAAE,qBAAqB,EAAE;;AAE3C;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,SAAS,eAAe,EAAE,oBAAoB,EAAE;;AAEhD,sBAAsB,UAAU,EAAE,WAAW,EAAE;AAC/C,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,2BAA2B,EAAE,kBAAkB,EAAE;;AAE7E,cAAc;AACd,YAAY,iBAAiB,EAAE;AAC/B,cAAc,mBAAmB,EAAE;AACnC,cAAc,sBAAsB,EAAE;;AAEtC,eAAe;AACf,oBAAoB,OAAO,UAAU,EAAE,0BAA0B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;AAClH,mBAAmB,WAAW,UAAU,EAAE,EAAE,MAAM,YAAY,EAAE,EAAE;;AAElE,WAAW,2BAA2B,EAAE;;AAExC,eAAe;AACf;EACE,OAAO,eAAe,EAAE;AAC1B","sourcesContent":["*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }\n\n:root {\n  --red: #c0392b;\n  --red-dark: #96281b;\n  --red-light: #f5e6e4;\n  --green: #1a5c38;\n  --green-mid: #27ae60;\n  --green-light: #e8f5ee;\n  --blue: #2563eb;\n  --blue-dark: #1d4ed8;\n  --black: #0d0d0d;\n  --gray-900: #1a1a1a;\n  --gray-700: #3d3d3d;\n  --gray-500: #6b6b6b;\n  --gray-300: #b0b0b0;\n  --gray-100: #f0f0f0;\n  --gray-50: #f8f8f8;\n  --white: #ffffff;\n  --border: #e2e2e2;\n  --shadow-sm: 0 1px 3px rgba(0,0,0,0.08);\n  --shadow: 0 2px 8px rgba(0,0,0,0.10);\n  --shadow-lg: 0 4px 20px rgba(0,0,0,0.12);\n  --radius: 6px;\n  --radius-lg: 10px;\n}\n\nhtml { font-size: 14px; }\n\nbody {\n  font-family: 'DM Sans', -apple-system, sans-serif;\n  background: var(--gray-50);\n  color: var(--gray-900);\n  -webkit-font-smoothing: antialiased;\n  line-height: 1.5;\n}\n\nh1, h2, h3, h4 {\n  font-family: 'DM Serif Display', Georgia, serif;\n  font-weight: 400;\n  line-height: 1.2;\n}\n\na { color: inherit; text-decoration: none; }\n\ninput, textarea, select {\n  font-family: inherit;\n  font-size: 0.875rem;\n}\n\nbutton { cursor: pointer; font-family: inherit; }\n\n::-webkit-scrollbar { width: 4px; height: 4px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb { background: var(--gray-300); border-radius: 2px; }\n\n/* Utilities */\n.text-red { color: var(--red); }\n.text-green { color: var(--green); }\n.text-muted { color: var(--gray-500); }\n\n/* Animations */\n@keyframes fadeIn { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }\n@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }\n\n.fade-in { animation: fadeIn 0.3s ease; }\n\n/* Responsive */\n@media (max-width: 768px) {\n  html { font-size: 13px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
